'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormControl = require('react-bootstrap/lib/FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FormControl2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/FormControl.js
// module id = 272
// module chunks = 0